import Icon from "@/components/Icon";
import { useLang } from "@/i18n";

export default function Marquee() {
    const { t } = useLang();
    const row = [...t.marquee, ...t.marquee];
    return (
        <div
            data-testid="editorial-marquee"
            aria-hidden="true"
            className="relative py-10 border-y border-ink/10 bg-elevated overflow-hidden select-none"
        >
            <div className="flex w-max animate-marquee gap-10 items-center">
                {[0, 1].map((half) => (
                    <div key={half} className="flex gap-10 items-center">
                        {row.map((item, i) => (
                            <span key={`${half}-${i}`} className="flex items-center gap-10">
                                <span className="font-heading font-bold text-4xl md:text-6xl tracking-tight text-stroke whitespace-nowrap">
                                    {item}
                                </span>
                                <Icon name="zap" size={22} className="text-solar/60 shrink-0" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
